export default __webpack_public_path__ + "static/media/Icon-Status-Outline-Forbidden.7bf3d7f0.svg";